var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.order.expires ? _c('div', {
    class: [_vm.sizeClass, 'secondary--text mt-2']
  }, [_c('div', {
    staticClass: "d-flex align-center flex-wrap",
    staticStyle: {
      "gap": "6px"
    }
  }, [_c('span', [_c('span', [_vm._v(_vm._s(_vm.isExpired ? "Expired at" : "Expires at") + " ")]), _c('code', {
    class: _vm.sizeClass
  }, [_vm._v(" " + _vm._s(_vm._f("getExpiresDate")(_vm.order.expires)) + " " + _vm._s(_vm._f("getExpiresTime")(_vm.order.expires)) + " (GMT+" + _vm._s(_vm.getGmtDiff) + ") ")])]), _vm.expiresCountdown && !_vm.isExpired ? _c('v-chip', {
    attrs: {
      "small": "",
      "color": _vm.isExpiringSoon ? 'error' : 'warning',
      "text-color": "white"
    }
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "left": ""
    }
  }, [_vm._v("mdi-clock-outline")]), _vm._v(" " + _vm._s(_vm.expiresCountdown) + " ")], 1) : _vm._e(), !_vm.isExpired && _vm.hasToraBooking ? _c('div', [_c('v-btn', {
    attrs: {
      "small": "",
      "color": "accent",
      "dark": "",
      "depressed": "",
      "loading": _vm.extendLoading
    },
    on: {
      "click": _vm.openExtendDialog
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": _vm.size === 'small'
    }
  }, [_vm._v("mdi-clock-plus-outline")]), _vm._v(" Extend ")], 1)], 1) : _vm._e(), _vm.isExpired && !_vm.order.isFullyPaid ? _c('v-chip', {
    attrs: {
      "small": _vm.size === 'small',
      "color": "error",
      "text-color": "white"
    }
  }, [_c('v-icon', {
    attrs: {
      "small": _vm.size === 'small',
      "left": ""
    }
  }, [_vm._v("mdi-clock-alert-outline")]), _vm._v(" EXPIRED ")], 1) : _vm._e()], 1)]) : !_vm.order.isFullyPaid ? _c('div', {
    class: [_vm.sizeClass, 'secondary--text mt-2']
  }, [_vm._m(0)]) : _vm._e(), _c('v-dialog', {
    attrs: {
      "max-width": "600px",
      "persistent": ""
    },
    model: {
      value: _vm.extendDialog,
      callback: function ($$v) {
        _vm.extendDialog = $$v;
      },
      expression: "extendDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "primary white--text"
  }, [_vm._v(" Extend Expiration Time ")]), _vm.extendData ? _c('v-card-text', {
    staticClass: "pt-5 px-6"
  }, [_vm.isExpirationUnchanged ? _c('v-card', {
    staticClass: "mb-4 pa-4",
    staticStyle: {
      "background-color": "#fff6d9"
    },
    attrs: {
      "outlined": ""
    }
  }, [_c('div', {
    staticClass: "d-flex align-center"
  }, [_c('v-icon', {
    staticClass: "mr-3",
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("mdi-alert-circle-outline")]), _c('span', [_vm._v(" The expiration time could not be extended and remains unchanged. ")])], 1)]) : _vm._e(), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "font-weight-medium py-2 label-cell"
  }, [_vm._v("Old Expiration")]), _c('td', {
    staticClass: "font-weight-medium py-2 colon-cell pr-3"
  }, [_vm._v(":")]), _c('td', {
    staticClass: "py-2 value-cell"
  }, [_vm._v(" " + _vm._s(_vm._f("getExpiresDate")(_vm.extendData.oldExpiration)) + " " + _vm._s(_vm._f("getExpiresTime")(_vm.extendData.oldExpiration)) + " (GMT+" + _vm._s(_vm.getGmtDiff) + ") ")])]), _c('tr', [_c('td', {
    staticClass: "font-weight-medium py-2 label-cell"
  }, [_vm._v("New Expiration")]), _c('td', {
    staticClass: "font-weight-medium py-2 colon-cell pr-3"
  }, [_vm._v(":")]), _c('td', {
    staticClass: "py-2 value-cell success--text font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm._f("getExpiresDate")(_vm.extendData.newExpiration)) + " " + _vm._s(_vm._f("getExpiresTime")(_vm.extendData.newExpiration)) + " (GMT+" + _vm._s(_vm.getGmtDiff) + ") ")])]), _vm.extendData.feePrice ? _c('tr', [_c('td', {
    staticClass: "font-weight-medium py-2 label-cell"
  }, [_vm._v("Extension Fee")]), _c('td', {
    staticClass: "font-weight-medium py-2 colon-cell pr-3"
  }, [_vm._v(":")]), _c('td', {
    staticClass: "py-2 value-cell font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.extendData.feePrice.plainText) + " ")])]) : _vm._e()])])], 1) : _vm._e(), _c('v-divider'), _c('v-card-actions', {
    staticClass: "pa-4"
  }, [_c('v-spacer'), _vm.isExpirationUnchanged ? [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.closeExtendDialog
    }
  }, [_vm._v(" CLOSE ")])] : [_c('v-btn', {
    attrs: {
      "color": "grey",
      "text": ""
    },
    on: {
      "click": _vm.closeExtendDialog
    }
  }, [_vm._v(" CANCEL ")]), _c('v-btn', {
    attrs: {
      "loading": _vm.confirmLoading,
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.confirmExtension
    }
  }, [_vm._v(" CONFIRM EXTENSION")])]], 2)], 1)], 1)], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-flex align-center",
    staticStyle: {
      "gap": "6px"
    }
  }, [_c('span', {
    staticClass: "grey--text"
  }, [_vm._v("No expiration date")])]);

}]

export { render, staticRenderFns }